import {EditableFieldModel} from "@white-label/components/page-builder/models/edit-component.model";
import {FieldType} from "@white-label/components/page-builder/models/model.map";
export enum NavigationTypes {
    FOOTER = 'footer',
    HEADER = 'header',
    TAB = 'tab',
    IN_PAGE = 'in_page'
}
export enum LayoutTypes {
    HORIZONTAL = 'horizontal',
    VERTICAL = 'vertical',
    COMPACT = 'compact',
}
export class NavigationModel {
    navigation = new EditableFieldModel('category', FieldType.array, [], NavigationCategory);
    type = new EditableFieldModel('type', FieldType.text, '');
    layout = new EditableFieldModel('layout', FieldType.text, '');

    fieldsMap = [this.navigation, this.type, this.layout];

    constructor(data?: {categories?: any, type: any, layout: any}) {
        if(data?.categories){
            this.navigation.value = [];
            for(let category of data?.categories.value){
                this.navigation.value.push(new NavigationCategory(category));
            }
        }
        if(data?.type){
            this.type.value = data.type.value;
        }
        if(data?.layout){
            this.layout.value = data.layout.value;
        }
    }
}

export class NavigationCategory {
    label = new EditableFieldModel('label', FieldType.text, 'New one');
    link = new EditableFieldModel('link', FieldType.text, '');
    icon = new EditableFieldModel('icon', FieldType.text, '');
    navigation = new EditableFieldModel('navigation', FieldType.array, [], NavigationCategory);
    expanded: boolean = false;
    fieldsMap = [this.label, this.link, this.icon, this.navigation];

    constructor(data?: {label?: any ,link?: any, icon?: any, navigation?: any}) {
        if(data?.navigation){
            this.navigation.value = [];
            for(let category of data?.navigation.value){
                this.navigation.value.push(new NavigationCategory(category));
            }
        }
        if(data?.label){
            this.label.value = data?.label.value;
        }
        if(data?.link){
            this.link.value = data?.link.value;
        }
        if(data?.icon){
            this.icon.value = data?.icon.value;
        }
    }
}
